import React from "react";
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';


export default function AttiSocietari({
    setInfoAggiuntive, 

    TipoSocietà,
    setTipoSocietà,
    setCapitaleSociale,
    TipoAttoSocieta,
    setTipoAttoSocieta,
    setNumeroCessioni,
    setElencoPrezziCessioni,
    setDescrizioneModifichePattiSociali,
    setDescrizioneOperazionePreventivo,
    setDescrizioneDelibereVerbalizzare
    }) {

	return (
		<>
            <MDBRow>
                <MDBCol>
                <div className="field">
                    <label className='customLab'>Tipo di società? </label>
                    <p>Selezionare una delle opzioni per mostrare i campi richiesti</p>
                    <select onChange={e => setTipoSocietà(e.target.value)} className="select">
                        <option default value="Scegliere">Non so</option>
                        <option value="Snc">Snc</option>
                        <option value="Sas">Sas</option>
                        <option value="Srl">Srl</option>
                        <option value="Spa">Spa</option>
                        <option value="Soc Coop">Soc Coop</option>
                        <option value="Società semplice">Società semplice</option>
                    </select>
                </div>
                </MDBCol>
            </MDBRow>
            
            <MDBRow>
                {(() => {
                    if (TipoSocietà != 'Scegliere') {
                        return (
                            <>
                            <MDBRow>
                                <MDBCol>
                                <div className="field">
                                    <label className='customLab'>Tipologia atto {TipoSocietà} </label>
                                    <p>Selezionare una delle opzioni per mostrare i campi richiesti</p>
                                    <select onChange={e => setTipoAttoSocieta(e.target.value)} className="select">
                                        <option default value="Scegliere">Non so</option>
                                        <option value="Atto costitutivo">Atto costitutivo</option>
                                        <option value="Cessione di quote">Cessione di quote</option>
                                        {(() => {
                                            if ( TipoSocietà === 'Snc' | TipoSocietà === 'Sas' | TipoSocietà === 'Società semplice') {
                                                return (
                                                    <option value="Modifica dei patti sociali">Modifica dei patti sociali</option>
                                                );
                                            }
                                            if ( TipoSocietà === 'Srl' | TipoSocietà === 'Spa' | TipoSocietà === 'Soc Coop') {
                                                return (
                                                    <option value="Verbale di assemblea">Verbale di assemblea</option>
                                                );
                                            }
                                        })()}
                                        <option value="Altro">Altro</option>
                                    </select>
                                </div>
                                </MDBCol>
                            </MDBRow>
                            {/* <MDBRow><strong>{TipoAttoSocieta}</strong></MDBRow> */}
                            {(() => {
                                if (TipoAttoSocieta === 'Atto costitutivo') {
                                    return (
                                        <>
                                        <MDBRow>
                                            <div className="field">
                                                <label className='customLab' >Ammontare del capitale sociale? </label>
                                                <input type="number" placeholder="500" name="capitaleSociale" id="capitaleSociale" onChange={e => setCapitaleSociale(e.target.value)} />
                                            </div>
                                        </MDBRow>
                                        </>
                                    );
                                }
                                if (TipoAttoSocieta === 'Cessione di quote') {
                                    return (
                                        <>
                                        <MDBRow>
                                            <div className="field">
                                                <label className='customLab'>Indicare il numero di cessioni da effettuare </label>
                                                <input type="number" placeholder="5" name="numeroCessioni" id="numeroCessioni" onChange={e => setNumeroCessioni(e.target.value)} />
                                            </div>
                                        </MDBRow>
                                        <MDBRow>
                                            <div className="field">
                                                <label className='customLab'>Indicare il prezzo di ogni cessione</label>
                                                <textarea className="message-field" type="textarea" placeholder="Elenco prezzi per cessione" name="elencoPrezziCessioni" id="elencoPrezziCessioni" onChange={e => setElencoPrezziCessioni(e.target.value)} />
                                            </div>
                                        </MDBRow>
                                        </>
                                    );
                                }
                                if ((TipoSocietà === 'Snc' | TipoSocietà === 'Sas' | TipoSocietà === 'Società semplice') & (TipoAttoSocieta === 'Modifica dei patti sociali') ) {
                                    return (
                                        <>
                                        <MDBRow>
                                            <div className="field">
                                                <label className='customLab'>Descrivere sommariamente le modifiche da effettuare</label>
                                                <textarea className="message-field" type="textarea" placeholder="Descrizione modifiche da effettuare" name="descrizioneModifichePattiSociali" id="descrizioneModifichePattiSociali" onChange={e => setDescrizioneModifichePattiSociali(e.target.value)} />
                                            </div>
                                        </MDBRow>
                                        </>
                                    );
                                }
                                if ((TipoSocietà === 'Srl' | TipoSocietà === 'Spa' | TipoSocietà === 'Soc Coop') & (TipoAttoSocieta === 'Verbale di assemblea')) {
                                    return (
                                        <>
                                        <MDBRow>
                                            <div className="field">
                                                <label className='customLab'>Descrivere sommariamente le delibere da verbalizzare</label>
                                                <textarea className="message-field" type="textarea" placeholder="Descrizione delibere da verbalizzare" name="descrizioneDelibereVerbalizzare" id="descrizioneDelibereVerbalizzare" onChange={e => setDescrizioneDelibereVerbalizzare(e.target.value)} />
                                            </div>
                                        </MDBRow>
                                        </>
                                    );
                                }
                                if (TipoAttoSocieta === 'Altro') {
                                    return (
                                        <>
                                        <MDBRow>
                                            <div className="field">
                                                <label className='customLab'>Descrivere l'operazione per cui si richiede il preventivo</label>
                                                <textarea className="message-field" type="textarea" placeholder="Descrizione operazione" name="descrizioneOperazionePreventivo" id="descrizioneOperazionePreventivo" onChange={e => setDescrizioneOperazionePreventivo(e.target.value)} />
                                            </div>
                                        </MDBRow>
                                        </>
                                    );
                                }
                            })()}
                            
                            </>
                        );
                    }



                })()}
            </MDBRow>

            {
                TipoSocietà!='Scegliere' ?
                <MDBRow>
                    <div className="field">
                        <label className='customLab' for="message">Informazioni aggiuntive</label>
                        <textarea className="message-field" type="textarea" placeholder="Informazioni" name="infoaggiuntive" id="infoaggiuntive" onChange={e => setInfoAggiuntive(e.target.value)} />
                    </div>
                </MDBRow>
                :
                null
            }


           
            </>
	);
}